import utils from "./utils";
import {initSliders} from 'slider';
import * as focusTrap from 'focus-trap';

'use strict';

class Modal {
  constructor(elem) {
    this.modal = elem;
    this.modalWrapper = elem.querySelector('.modal-wrapper');
    this.openModalButton = document.querySelectorAll(`[data-modal-button-open="${this.modal.dataset.modal}"]`);
    this.closeModalButton = document.querySelectorAll(`[data-modal-button-close="${this.modal.dataset.modal}"]`);
    this.body = document.getElementsByTagName('body')[0];
    this.modal.modalFocusTrap = this.modal.modalFocusTrap ? this.modal.modalFocusTrap : focusTrap.createFocusTrap(this.modal);
    this.events();
  }

  events() {
    this.removeModalFromKeyboardNavigation();

    // Mobile only modal
    if (this.modal.classList.contains('modal-mobile-only')) {
      if (utils.mq.md.matches) {
        this.initMobileModal()
      } else {
        this.addModalToKeyboardNavigation();
        this.closeModalButton.forEach(button => button.setAttribute('tabindex', '-1'));
      }
    }

    utils.mq.md.addListener(e => {
      if (!this.modal.classList.contains('mysiblu')) {
        if (e.matches && this.modal.classList.contains('modal-mobile-only')) {
          this.initMobileModal();
        } else {
          this.destroyMobileModal();
        }
      }
    });

    if (this.modal) {
      this.openModalButton.forEach(button => {
        button.addEventListener('click', (event) => {
          this.openModal();
        });
      });

      this.closeModalButton.forEach(button => {
        button.addEventListener('click', (event) => {
          this.closeModal();
        });
      });

      if (this.modal.classList.contains('modal-hidden')) {
        document.addEventListener('keydown', (e) => {
          e.key === "Escape" && this.closeModal();
        });
      }
    }
  }

  loadModal() {
    if (this.modal.classList.contains('modal-mobile-only')) {
      this.modal.classList.remove('d-n@<md');
    } else {
      this.modal.classList.remove('d-n');
    }
  }

  unLoadModal() {
    if (this.modal.classList.contains('modal-mobile-only')) {
      this.modal.classList.add('d-n@<md');
    } else {
      this.modal.classList.add('d-n');
    }
  }

  openModal() {
    this.loadModal();
    setTimeout(() => {
      this.addModalToKeyboardNavigation();
      this.modal.classList.remove('modal-hidden');
      this.modal.setAttribute('data-open', true);
      this.body.classList.add('o-h');
      initSliders();
      this.modal.modalFocusTrap.activate();
    }, 50);
  }

  closeModal() {
    this.removeModalFromKeyboardNavigation();
    this.modal.classList.add('modal-hidden');
    this.modal.setAttribute('data-open', false);
    this.body.classList.remove('o-h');
    this.modal.modalFocusTrap.deactivate();

    setTimeout(() => {
      this.unLoadModal();
    }, 300);
  }

  initMobileModal() {
    if (!this.modal.getAttribute('data-open')) {
      this.modal.classList.add('modal', 'modal-hidden', 'modal-overlayed');
      this.modal.setAttribute('role','dialog');
      this.modal.setAttribute('aria-modal','true');
    }

  }

  destroyMobileModal() {
    this.modal.classList.remove('modal', 'modal-hidden', 'modal-overlayed');
    this.modal.removeAttribute('role');
    this.modal.removeAttribute('aria-modal');
    this.addModalToKeyboardNavigation();
  }

  removeModalFromKeyboardNavigation() {
    this.modal.setAttribute('tabindex', '-1');
  }

  addModalToKeyboardNavigation() {
    this.modal.removeAttribute('tabindex');
  }
}

const initModals = (wrapper = document) => {
  const modals = wrapper.querySelectorAll('[data-modal]');

  modals.forEach((modal) => {
    modal.modal = new Modal(modal);
  });
}

initModals();
/* LISTEN FOR RELOAD AFTER AJAX CALL */
document.addEventListener('reloadModal', (e) => {
  initModals(e.detail.wrapper);
}, false);
